import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledWrapper = styled.div`
  display: flex;
  height: 100%;
  min-width: 279px;

  section {
    z-index: 999999;
  }
`;

export const StyledMainContainer = styled.div`
  ${({isMileageInputed = false}) => {
    return`
      align-items: flex-start;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      margin-left: ${isMileageInputed ? '0' : '-8.3vw'};
      margin-right: ${isMileageInputed ? '0' : '-8.3vw'};

      @media (min-width: ${Breakpoints.b560}px) {
        margin-left: 0;
        margin-right: 0;
        width: 100%;
      }
    `;
  }}
`;

export const StyledContainer = styled.div`
  align-self: stretch;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.border.divider};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${(props: any) => props.theme.size.static250};

  @media (min-width: ${Breakpoints.b560}px) {
    border-radius: 4px;
    border: 1px solid ${(props: any) => props.theme.colors.border.divider};
  }
`;

export const StyledMileageContainer = styled.div`
  align-items: center;
  background: rgba(223, 228, 232, 0.48);
  border-bottom: 1px solid ${(props: any) => props.theme.colors.filter.off.disabled};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${(props: any) => props.theme.size.static350} 0px;

  > p {
    color: ${(props: any) => props.theme.colors.content.tertiary};
  }

  > p + p {
    color: ${(props: any) => props.theme.colors.content.active};
  }
`;